import React from 'react';
import { Bar } from 'react-chartjs-2';




const options = {
	 chart: {
        type: 'column'
    },
    title: {
	    text: ''
    },
    plugins: {
        legend: {
            display: false
                }
    },
     scales:{
    xAxes: {
       ticks:{
                    color: 'black'
                },
        isStacked: 'percent',
         grid: {
               display: false,
               drawBorder: false
               }
        
    },
    yAxes: {
       ticks:{
                    color: 'black'
                },
      grid: {
               display: false,
               drawBorder: false,

               }
    }
  },
    tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true
    },
    plotOptions: {
        column: {
            stacking: 'percent'
        }
    },
   }

function StackedBarChart(props) {
  console.log(props.data.month, props.data.data)
  let month=['Jan','Feb','Mar','Apr','May','Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  let converMonth=[]
  console.log(props)
  if(props.data!==false){

    props.data.month.forEach(key=>{
      converMonth.push(month[key])
    })
  }
  const data = {
    labels: converMonth,
  datasets: [
    {
      label: 'Total Request Pending',
      data: props.data.data,
      backgroundColor: ['rgba(236,52,136)']
    }
   ]
}
  return (
   <Bar data= {data} options={options} />
  );
}
export default StackedBarChart;
